import type * as models from 'pkg/api/models';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum OrderRowTypes {
	Product = 'product',
	Fee = 'fee',
	Discount = 'discount',
}

export interface OrderRow extends Record, Dateable {
	id: number;
	orderId: number;
	productPriceId: number;
	description?: string;
	quantity: number;
	taxRateId: number;
	validTo: number;
	amount: number;
	taxPercentage: number;
	taxInclusive: boolean;
	discountId?: number;
	type: OrderRowTypes;

	productPrice?: models.productPrice.ProductPrice;
	taxRate?: models.taxRate.TaxRate;
	discount?: models.discount.Discount;
}
